import CryptoJs from "crypto-js";
import axiosCall from "../axiosCall";
import { OAUTH_CLIENT_SECRET, REGISTRATION_CLIENT_SECRET_PPP, REGISTRATION_CLIENT_SECRET_FAF, REGISTRATION_CLIENT_SECRET_CPR, SUPERTOKEN_OAUTHURL_PPP, SUPERTOKEN_OAUTHURL_FAF, SUPERTOKEN_OAUTHURL_CPR, OAUTH_CLIENT_SECRET_FAF, OAUTH_CLIENT_SECRET_CPR, OAUTH_CLIENT_SECRET_PPP, PARTNER_AUTH, preLoginToken_PPP, postLoginToken_PPP, authToken_PPP, FAF_AUTH, preLoginToken_FAF, postLoginToken_FAF, authToken_FAF, CPR_AUTH, preLoginToken_CPR, postLoginToken_CPR, authToken_CPR, jwtToken_PPP, jwt_PPP, jwt_CPR, jwtToken_CPR, jwtToken_FAF, jwt_FAF, SUPERTOKEN_BASE_URL, BASE_URL, CLIENT_ID_FAF, CLIENT_ID_CPR, CLIENT_ID_PPP, IS_DATA_ENCRYPTED, PARTNER_AK_VALUE, CPR_AK_VALUE, FAF_AK_VALUE, CASE_AK_VALUE } from "../../constant/Constants";
import axios from "axios";
import Session from "supertokens-web-js/recipe/session";
import { toast } from "react-toastify";
export const getRegistrationTokenPPP = async (callback = '') => {
    const data = {
        "grant_type": "password",
        "username": "PPPAPI",
        "password": "rules@12",
        "client_id": CLIENT_ID_PPP,
        "client_secret": REGISTRATION_CLIENT_SECRET_PPP,
    }
    let authorization = {
        "Content-Type": "application/json",
    };
    try {
        const response = await axios({
            method: "post",
            url: `${SUPERTOKEN_OAUTHURL_PPP}/oauth2/v1/token`,
            headers: authorization,
            params: null,
            data: {}
        });
        if (response) {
            PARTNER_AUTH.Authorization = `Bearer ${response.data.access_token}`;
            preLoginToken_PPP.token = `Bearer ${response.data.access_token}`;
            authToken_PPP.token = `Bearer ${response.data.access_token}`;
            if (callback != '') {
                callback();
                return { res: response.data }
            } else {
                return `Bearer ${response.data.access_token}`;
            }
        } else {
            if (callback != '') {
                callback()
            } else {
                return false
            }
        }
        return { res: response.data }
    } catch (err) {
        if (callback != '') {
            callback(err)
        } else {
            return false
        }
    }

    // const response = await axiosCall('post', `${SUPERTOKEN_OAUTHURL_PPP}/oauth2/v1/token`, authorization, null, data, "supertoken");
}
export const getRegistrationTokenFAF = async (callback = '') => {
    const data = {
        "grant_type": "password",
        "username": "FAFAPI",
        "password": "rules@12",
        "client_id": CLIENT_ID_FAF,
        "client_secret": REGISTRATION_CLIENT_SECRET_FAF,
    }
    let authorization = {
        "Content-Type": "application/json",
    };
    try {
        const response = await axios({
            method: "post",
            url: `${SUPERTOKEN_OAUTHURL_FAF}/oauth2/v1/token`,
            headers: authorization,
            params: null,
            data: {}
        });
        // const response = await axiosCall('post', `${SUPERTOKEN_OAUTHURL_FAF}/oauth2/v1/token`, authorization, null, data, prgData);

        if (response) {
            FAF_AUTH.Authorization = `Bearer ${response.data.access_token}`;
            preLoginToken_FAF.token = `Bearer ${response.data.access_token}`;
            authToken_FAF.token = `Bearer ${response.data.access_token}`;
            if (callback != '') {
                callback();
                return { res: response.data }
            } else {
                return `Bearer ${response.data.access_token}`;
            }
        } else {
            if (callback != '') {
                callback()
            } else {
                return false
            }
        }
    } catch {
        if (callback != '') {
            callback()
        } else {
            return false
        }
    }
}
export const getRegistrationTokenCPR = async (callback = '') => {
    const data = {
        "grant_type": "password",
        "username": "CPRAPI",
        "password": "rules@12",
        "client_id": CLIENT_ID_CPR,
        "client_secret": REGISTRATION_CLIENT_SECRET_CPR,
    }
    let authorization = {
        "Content-Type": "application/json",
    };
    try {
        const response = await axios({
            method: "post",
            url: `${SUPERTOKEN_OAUTHURL_CPR}/oauth2/v1/token`,
            headers: authorization,
            params: null,
            data: {}
        });
        // const response = await axiosCall('post', `${SUPERTOKEN_OAUTHURL_CPR}/oauth2/v1/token`, authorization, null, data, prgData);

        if (response) {
            CPR_AUTH.Authorization = `Bearer ${response.data.access_token}`;
            preLoginToken_CPR.token = `Bearer ${response.data.access_token}`;
            authToken_CPR.token = `Bearer ${response.data.access_token}`;
            if (callback != '') {
                callback();
                return { res: response.data }
            } else {
                return `Bearer ${response.data.access_token}`;
            }
        } else {
            if (callback != '') {
                callback()
            } else {
                return false
            }
        }
        return { res: response.data }
    } catch {
        if (callback != '') {
            callback()
        } else {
            return false
        }
    }

}

export const getOAuthToken = async (jwt, param) => {
    let OAuthURL = ''
    let client_secretId = ''
    let client_id_T = ''
    let client_secret = ''
    if (param == "CPR") {
        OAuthURL = SUPERTOKEN_OAUTHURL_CPR
        client_secretId = OAUTH_CLIENT_SECRET_CPR
        client_id_T = '1080874436757226067'
        client_secret = REGISTRATION_CLIENT_SECRET_CPR
    } else if (param == "FAF") {
        client_secretId = OAUTH_CLIENT_SECRET_FAF
        OAuthURL = SUPERTOKEN_OAUTHURL_FAF
        client_id_T = '11080874436757226067'
        client_secret = REGISTRATION_CLIENT_SECRET_FAF
    } else {
        client_secretId = OAUTH_CLIENT_SECRET_PPP
        OAuthURL = SUPERTOKEN_OAUTHURL_PPP
        client_id_T = '14995289931953580127'
        client_secret = "1157705D06C268496445BCE0C666D564"

    }
    const data = {
        grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
        client_id: "14995289931953580127",
        client_secret: OAUTH_CLIENT_SECRET_PPP,
        assertion: jwt
    }
    const urlEncodedData = new URLSearchParams(jwt).toString();

    let authorization = {
        "Content-Type": "application/x-www-form-urlencoded",
    };
    try {


        const response = await axiosCall('post', `${OAuthURL}/oauth2/v1/token`, authorization, null, urlEncodedData, null);
        let resData = response.data
        if (param == "CPR") {
            CPR_AUTH.Authorization = `Bearer ${resData.access_token}`;
            postLoginToken_CPR.token = `Bearer ${resData.access_token}`;
            authToken_CPR.token = `Bearer ${resData.access_token}`;
        } else if (param == "FAF") {
            FAF_AUTH.Authorization = `Bearer ${resData.access_token}`;
            postLoginToken_FAF.token = `Bearer ${resData.access_token}`;
            authToken_FAF.token = `Bearer ${resData.access_token}`;
        } else {
            PARTNER_AUTH.Authorization = `Bearer ${resData.access_token}`;
            postLoginToken_PPP.token = `Bearer ${resData.access_token}`;
            authToken_PPP.token = `Bearer ${resData.access_token}`;
        }
        return { res: response.data, program: param }
    } catch {
        return false
    }
}
export const session = async (id) => {
    // let authorization =  {
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    //      credentials: "include",
    // }
    // const response = await axiosCall('get', `${SUPERTOKEN_OAUTHURL_PPP}/sessioninfo`, authorization, null, null, prgData);
    const response = await axios.get(`${SUPERTOKEN_BASE_URL}/sessioninfo`, {
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    })
    return { res: response.data }
}

export const getJwtToken = async (email, prgData, callBack = () => { }, metaDataReq) => {
    let auth = ''
    if (prgData == "CPR") {
        auth = "CPRAPI"
    } else if (prgData == "FAF") {
        auth = "FAFAPI"
    } else {
        auth = "PPPAPI"
    }
    const data = JSON.stringify({
        email: email,
        aud: "microservice",
        sub: "microservice",
        username: auth
    })

    try {
        const response = await axios.post(
            `${SUPERTOKEN_BASE_URL}/getJwtToken`,
            data, // Request body
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true, // This ensures cookies are sent with the request
            }
        );
        let jwtData = response.data
        if (prgData == "CPR") {
            jwtToken_CPR.token = jwtData.token.jwt;
            jwt_CPR.token = jwtData.token.jwt
            callBack(jwtData.token, metaDataReq)
        } else if (prgData == "FAF") {
            jwtToken_FAF.token = jwtData.token.jwt;
            jwt_FAF.token = jwtData.token.jwt;
            callBack(jwtData.token, metaDataReq)
        } else {
            jwtToken_PPP.token = jwtData.token.jwt;
            jwt_PPP.token = jwtData.token.jwt;
            callBack(jwtData.token, metaDataReq)
        }
        return { res: jwtData }
    } catch {
        return false
    }


}

export const verifyEmail = async (token) => {
    const data = {
        "method": "token",
        "token": token
    }

    const response = await axiosCall('post', `/user/email/verify`, null, null, data, 'supertoken');
    return { res: response.data }
}

export const verificationMailSent = async (data, prgData) => {
    // const headers = {
    //     withCredentials: true, // This enables credentials
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // }
    // const response = await axiosCall('post', `${SUPERTOKEN_BASE_URL}/auth/verify-email`, headers, null, data, 'supertoken');
    const response = await axios.post(`${SUPERTOKEN_BASE_URL}/auth/verify-email`, data, {
        withCredentials: true, // This enables credentials
        headers: {
            "Content-Type": "application/json",
        },
    })
    return { res: response.data, program: prgData }
}

export const getMetaData = async (id) => {

    try {
        const response = await axios.get(`${SUPERTOKEN_BASE_URL}/meta-data/`, {
            params: { id }, // Use `params` to append the query parameter
            headers: {
                "Content-Type": "application/json", // Specify content type
            },
            withCredentials: true, // This ensures cookies are sent with the request
        });

        return { res: response.data }
    } catch {
        return false
    }

}
export const setIsAgreedtoTerms = async (id) => {
    try {
        const response = await axios.put(
            `${SUPERTOKEN_BASE_URL}/meta-data-update/?id=${id}`,
            {
                email: "",
                metaData: {
                    IsAgreedtoTerms: true,
                },
                isResetPassword: false,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": `Bearer YOUR_AUTH_TOKEN`, // Include auth token if needed
                },
            }
        );

        return response.data
    } catch (err) {
    }
}
export const updatePasswordAPI = async (token, password, prgData) => {
    const data = {
        formFields: [{
            id: "password",
            value: CryptoJs.MD5(password).toString()
        }],
        "method": "token",
        "token": token
    }
    try {
        const response = await axiosCall('post', `/user/password/reset`, null, null, data, 'supertoken');
        return response.data
        return { res: response.data, program: prgData }
    } catch {
        return false
    }

}

export const getPortalUserDetails = async (id, prgData) => {
    try {
        // const response = await axios.get(
        //     `${BASE_URL}/v1/data/D_GetPartnerPortalUserDetails?SuperTokenUserID=${id}`, // Fixed query parameter
        //     {
        //         headers: {
        //             "Content-Type": "application/json",
        //             "Authorization": PARTNER_AUTH.Authorization,
        //         },
        //         // withCredentials: true, // Ensures cookies are included
        //     }
        // );

        // const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
        const response = await axiosCall('get', `/v1/data/D_GetPartnerPortalUserDetails?`, PARTNER_AUTH, `SuperTokenUserID=${id}`, null, "PARTNER");
        // return response.data

        return (response.data)
    } catch (error) {
        return false;
    }

}

export const settingSecondFactorId = async ({ id, portalId }) => {

    try {
        const response = await axios.post(`${BASE_URL}/Partner/v1/UpdatePartnerPortalUser`, {
            "PortalUser":
            {
                "PortalID": portalId,
                "PassWordlessReceipeID": id,
            }
        }, {
            // withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                "Authorization": PARTNER_AUTH.Authorization,
            },
        });
        return { res: response.data }
    } catch {
        return false
    }

}

export const passworlessUpdate = async (data, prgData) => {

    try {
        const response = await axios.post(`${SUPERTOKEN_BASE_URL}/passwordless-update`, data, {
            withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                // "Authorization": preAuthService.basicAuth
            },
        });
        return { res: response.data, program: prgData }
    } catch {
        return false
    }

}

export const revokeSession = async (sessionToken, prgData) => {
    const data = {
        client_id: "74884855196682858826",
        client_secret: OAUTH_CLIENT_SECRET_PPP,
        token: sessionToken
    }
    const urlEncodedData = new URLSearchParams(data).toString();

    let authorization = {
        "Content-Type": "application/x-www-form-urlencoded",
    };

    try {
        const response = await axiosCall('post', `${SUPERTOKEN_OAUTHURL_PPP}/oauth2/v1/revoke`, authorization, null, urlEncodedData, prgData);
        return { res: response.data, program: prgData }
    } catch {
        return false
    }

}

export const getAllSessions = async (id, sessionID, callBack = () => { }, rememberMeFlag) => {
    try {
        const response = await axiosCall('get', `/get-all-sessions?`, null, `id=${id}`, null, 'supertoken');
        if (callBack == 'isActiveSession') {
            if (response.data[0] != sessionID) {
                rememberMeFlag != "true" && await Session.signOut();
                toast.error('Session Expired!');
                setTimeout(() => {
                    window.location.assign(window.location.origin);
                }, 2000);
            } else {
                callBack(response.data)
            }
        }
        return response.data
    } catch {
        return false
    }
}

export const supertokenRevoke = async (id) => {
    try {
        const response = await axiosCall('delete', `/revoke-session?`, null, `id=${id}`, null, 'supertoken');
        return { res: response.data }
    } catch {
        return false
    }

}

export const passworlessSignUp = async (email) => {
    const data = {
        email
    }
    try {
        const response = await axiosCall('post', `/passwordless-signup?`, null, null, data, 'supertoken');
        return { res: response.data }
    } catch {
        return false
    }

}
export const memberData = async (MemberID, callBack = () => { }) => {
    try {
        const response = await axiosCall('get', `v1/data/D_Member_Lookup?`, null, `MemberID=${MemberID}`, null, 'supertoken');
        callBack(response.data)
        return { res: response.data }
    } catch {
        return false
    }

}

export const getUserData = async (id) => {
    try {
        let authorization = {
            "Content-Type": "application/json",
        }
        // const response = axios.get(`${SUPERTOKEN_BASE_URL}/get-user-details?id=${id}`, {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        const response = await axios.get(`${SUPERTOKEN_BASE_URL}/get-user-details?id=${id}`, {
            // withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                // "Authorization": preAuthService.basicAuth
            },
        });

        return response.data

    } catch {
        return false
    }

}

export const getTokenEncryption = async () => {
    try {
        const response = await axios.get(`${SUPERTOKEN_BASE_URL}/get-token`, {
            // withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                // "Authorization": preAuthService.basicAuth
            },
        });


        PARTNER_AK_VALUE.value = response.data.response
        CASE_AK_VALUE.value = response?.data?.response || "--"

        return response.data

    } catch {
        return false
    }

}

export const getCPRTokenEncryption = async () => {
    try {
        const response = await axios.get(`${SUPERTOKEN_BASE_URL}/get-cpr-token`, {
            // withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                // "Authorization": preAuthService.basicAuth
            },
        });


        CPR_AK_VALUE.value = response?.data?.response || "--"

        return response.data

    } catch {
        return false
    }

}

export const getFAFTokenEncryption = async () => {
    try {
        const response = await axios.get(`${SUPERTOKEN_BASE_URL}/get-faf-token`, {
            // withCredentials: true, // This enables credentials
            headers: {
                "Content-Type": "application/json",
                // "Authorization": preAuthService.basicAuth
            },
        });


        FAF_AK_VALUE.value = response?.data?.response || "--"

        return response.data

    } catch {
        return false
    }

}


